module.exports = __webpack_public_path__ + "media/images/business/img-about-507359e1865a35c573fa1e48dbc42db8.png";